// Labels and printouts (N12): a small "Print" menu of PDFs (server/src/labels.ts), each opening in a new tab to print.
import { Printer } from "lucide-react";
import { Button } from "./controls.tsx";
import { Popover } from "./Popover.tsx";

export function PrintMenu({
  items,
  label = "Print",
  size = "sm",
}: {
  items: { label: string; hint?: string; href: string }[];
  label?: string;
  size?: "sm" | "md";
}) {
  return (
    <Popover
      width={260}
      button={(toggle) => (
        <Button size={size} icon={<Printer className="size-3.5" />} onClick={toggle}>
          {label}
        </Button>
      )}
    >
      {(close) => (
        <div className="flex flex-col gap-0.5 text-[12px]">
          {items.map((it) => (
            <a key={it.href} href={it.href} target="_blank" rel="noreferrer" onClick={close} className="flex flex-col rounded px-2 py-1.5 hover:bg-hover">
              <span className="font-medium">{it.label}</span>
              {it.hint && <span className="text-[11px] text-muted">{it.hint}</span>}
            </a>
          ))}
        </div>
      )}
    </Popover>
  );
}
